import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../Create_Assessment_PreRead/create/createPreRead.css";
import CreatePublishPreRead from "../create_published/CreatePublishPreRead";
import axios from "../../../../axios";
import Form from "react-bootstrap/Form";
import Attachment from "./Attachment";
import { IoIosArrowBack } from "react-icons/io";
import assets from "../../../../assets/assets";
import { toast } from "react-toastify";
import { Link } from "lucide-react";
import Camera from "react-html5-camera-photo";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";

import AddLinkPopup from "../../../../ContentManagement/LiveSession/LiveSessionDetail.js/SubjectDatailsCM/AddLinkPopup";
import {
  Box,
  Stack,
  Typography,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Divider,
  Link as MuiLink,
  IconButton,
} from "@mui/material";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
export let res;

let dummyArr = [];

const getSelectedValueSE = () => {
  var select = document.getElementById("bello");
  let result = {
    id: select.options[select.selectedIndex].value,
    name: select.options[select.selectedIndex].text,
  };

  return result;
};

function CreatePreRead() {
  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON = JSON.parse(general_role);

  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON = JSON.parse(classTeacher);

  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON = JSON.parse(cordinator);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [publish, setPublish] = useState();
  const [attachMent, setAttachment] = useState([]);

  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [attach, setAttach] = useState([]);
  const [errorsize, setErrorSize] = useState(false);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [loader, setLoader] = useState(false);
  const [cameraError, setCameraError] = useState(null);

  const isProcessing = loader;

  const [prereadState, setPrereadState] = useState({
    description: "",
    tittle: "",
    subjects: "",
    sections: "",
    classes: "",
    chapters: "",
    book: "",
    pretypes: "",
    // attach: [],
  });

  const {
    subjects,
    sections,
    classes,
    chapters,
    book,
    description,
    tittle,
    pretypes,
  } = prereadState;

  const SavedPreRead = JSON.parse(localStorage.getItem("prereadStateLocal"));
  const prevStateRef = useRef(prereadState);
  const saveTimer = useRef(null);

  const [showLinkBox, setShowLinkBox] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [linkValue, setLinkValue] = useState("");

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  // load saved state on mount
  useEffect(() => {
    if (SavedPreRead) {
      setPrereadState(SavedPreRead);
    }
  }, []);

  let newPreRead = {
    standard_name: classes.split(",")[0],
    subject_name: subjects.split(",")[0],
    section_name: sections.split(",")[0],
  };

  const [preDropdowns, setPreDropdowns] = useState({
    chapterDropdown: [],
    pretypeDropdown: [],
  });
  const { chapterDropdown, pretypeDropdown } = preDropdowns;

  const [subjectsList, setSubjectsList] = useState([]);

  let school_id = JSON.parse(localStorage.getItem("schoolId"));

  useEffect(() => {
    const getAllPreDropdown = async () => {
      try {
        const chapter = await axios.get(
          `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${
            classes.split(",")[1]
          }&section_id=${sections.split(",")[1]}&subject_id=${
            subjects.split(",")[1]
          }&timetableSessionId=${timeTableSessionId}`,
        );
        const pretype = await axios.get(
          `/api/v1/homework/preReadType/getBySchool/${school_id}`,
        );
        chapter &&
          pretype &&
          setPreDropdowns({
            chapterDropdown: chapter.data.data,
            pretypeDropdown: pretype.data.data,
          });
      } catch (error) {}
    };
    if (classes && sections && subjects) {
      getAllPreDropdown();
    }
  }, [classes, sections, subjects]);

  //////subject/////////
  useEffect(() => {
    let dummyArr = [];
    (async () => {
      try {
        function addUniqueObjectToArray(obj) {
          if (
            !dummyArr.some(
              (item) => JSON.stringify(item) === JSON.stringify(obj),
            )
          ) {
            dummyArr.push(obj);
          }
        }

        // generalRole_JSON?.map((obj) =>
        //   obj?.subjects_id?.map((para) => addUniqueObjectToArray(para))
        // );
        let subjects = [];
        if (classTeacher_JSON?.length > 0 || cordinator_JSON?.length > 0) {
          subjects = await getSubjects(
            classes.split(",")[1],
            sections.split(",")[1],
          ); //obj.subjects_id;
        }
        if (classTeacher_JSON?.length > 0) {
          classTeacher_JSON?.forEach(async (obj) => {
            if (
              obj.standard_id.id === classes.split(",")[1] &&
              obj.section_id.id === sections.split(",")[1]
            ) {
              subjects.map((obj) => addUniqueObjectToArray(obj));
            }
          });
        }

        if (cordinator_JSON?.length > 0) {
          cordinator_JSON?.forEach(async (obj) => {
            if (
              obj.standard_id.id === classes.split(",")[1] &&
              obj.section_id.id === sections.split(",")[1]
            ) {
              subjects.map((obj) => addUniqueObjectToArray(obj));
            }
          });
        }

        if (generalRole_JSON.length > 0) {
          generalRole_JSON?.forEach((obj) => {
            if (
              obj.standard_id.id === classes.split(",")[1] &&
              obj.section_id.id === sections.split(",")[1]
            ) {
              obj?.subjects_id?.map((para) => addUniqueObjectToArray(para));
            }
          });
        }
        setSubjectsList(dummyArr);
      } catch (error) {
        console.log(error);
      }
    })();

    //getsubjectList();
  }, [classes, sections]);

  const getSubjects = async (standard_id, section_id) => {
    let arrSubject = [];
    try {
      if (standard_id && section_id) {
        let res = await axios.get(
          `/api/v1/school/standardId/${standard_id}/sectionId/${section_id}/getSubjects`,
        );

        const data = res?.data?.data;

        // Priority: subjectConfigurations > subjects
        const subjectSource =
          data?.subjectConfigurations?.length > 0
            ? data.subjectConfigurations.map((item) => item.subject)
            : data.subjects;

        subjectSource.forEach((obj) => {
          arrSubject.push(obj);
        });
      }
    } catch (error) {
      console.log(error);
    }
    return arrSubject;
  };

  ///////////////////////class/////////////////////////
  let sectionArr = [];
  let standardArr = [];
  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
  };

  dropDownHelper();

  /////////////////////section//////////////////////////////

  let standSecId = state?.standardId
    ? state?.standardId
    : prereadState.classes.split(",")[1];
  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) => {
      if (obj?.standard_id?.id === standSecId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.map((obj) => {
      if (obj?.standard_id?.id === standSecId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.map((obj) => {
      if (obj?.standard_id?.id === standSecId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  //////////////////////////////////////////////////////
  let createPreRead = {
    standard_id: classes.split(",")[1],
    subject_id: subjects.split(",")[1],
    section_id: sections.split(",")[1],
    chapter_id: chapters,
    book_id: book,
    academic_session_id: academicSessionId,
    timetable_session_id: timeTableSessionId,
    attachments_sizeKb: Math.round(attachMent.map((file) => file.size / 1024)),
    type: pretypes.split(",")[1],
    teacher_id: Teacher_Json,
    status: "draft",
    description: description.trim(),
    name: tittle,
    attachments: attach,
  };

  const handleAttach = async (id, attachPath) => {
    const hasHttps = attach.some((item) => item.startsWith("https://"));
    if (hasHttps) {
      const newArray = [...attach];
      const newArrayFiltered = newArray.filter((_, index) => index !== id);
      console.log(newArrayFiltered, "newArrayFiltered");
      setAttach(newArrayFiltered);

      let updatedAttachments = {
        attachments: newArrayFiltered,
        attachments_sizeKb: [],
      };
      setLoader(true);
      try {
        let res = await axios.delete(`/api/v1/file/delete`, {
          data: { file_path: updatedAttachments },
        });
        if (res) {
          setLoader(false);
          setAttach(newArray);
          setAttachment(newArrayFiltered);
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoader(false);
      }
    } else {
      const newArray = [...attach];
      const newArrayLimit = [...attachMent];
      newArray.splice(id, 1);
      newArrayLimit.splice(id, 1);
      await axios.delete(`/api/v1/file/delete`, {
        data: { file_path: attachPath },
      });
      setAttach(newArray);
      setAttachment(newArrayLimit);
    }
  };
  console.log(attach);
  const helper = async () => {
    try {
      const res = await axios.post(
        `/api/v1/homework/preRead/create`,
        createPreRead,
      );

      res && console.log(res.data.data);

      navigate("/PublishedHomeworkPreRead");
    } catch (error) {
      console.log(error);
    } finally {
      localStorage.removeItem("prereadStateLocal");
    }
  };

  const validateFile = (file) => {
    const allowedExtensions = /\.(jpg|jpeg|png|pdf|mp3|mp4|pptx|ppt)$/i;

    // ✅ total attachments count (ALL types)
    if (attach.length >= 5) {
      toast.error("Maximum 5 attachments allowed");
      return false;
    }

    // ❌ file type
    if (!allowedExtensions.exec(file.name)) {
      toast.error("Invalid file type");
      return false;
    }

    // ❌ size
    if (file.size > 10 * 1024 * 1024) {
      toast.error("File must be under 10MB");
      return false;
    }

    return true;
  };
  // console.log("createPreRead", createPreRead);

  const errors = {};

  const isDisableButtons =
    prereadState.tittle.trim() === "" ||
    prereadState.subjects === "" ||
    prereadState.sections === "" ||
    prereadState.classes === "" ||
    prereadState.chapters === "" ||
    prereadState.pretypes === "" ||
    prereadState.description.trim() === "" ||
    Object.keys(errors).length > 0;

  const isDisableButtons1 =
    (prereadState.tittle.trim() === "" &&
      prereadState.subjects === "" &&
      prereadState.sections === "" &&
      prereadState.classes === "" &&
      prereadState.chapters === "" &&
      prereadState.pretypes === "" &&
      prereadState.description.trim() === "") ||
    Object.keys(errors).length > 0;

  useEffect(() => {
    if (
      standardArr &&
      standardArr.length > 0 &&
      sectionArr &&
      sectionArr.length > 0 &&
      state?.standardId !== undefined &&
      state?.sectionId !== undefined
    ) {
      let standard = standardArr.filter(
        (standard) => standard.id === state.standardId,
      );
      let section = sectionArr.filter(
        (section) => section.id === state.sectionId,
      );
      setPrereadState((prev) => {
        return {
          ...prev,
          sections: section[0]["name"] + "," + section[0]["id"],
          classes: standard[0]["name"] + "," + standard[0]["id"],
        };
      });
    }
  }, []);

  useEffect(() => {
    if (
      subjectsList &&
      subjectsList.length > 0 &&
      state?.subjectId !== undefined
    ) {
      let subject = subjectsList.filter(
        (subject) => subject.id === state.subjectId,
      );
      if (subject.length === 0) {
        return;
      }
      setPrereadState((prev) => {
        return {
          ...prev,
          subjects: subject[0]["name"] + "," + subject[0]["id"],
        };
      });
    }
  }, [subjectsList]);

  // save only when changes happen
  useEffect(() => {
    // agar disabled hai to skip
    if (isDisableButtons1) return;

    // prev aur current same hain? → skip save
    const isSame =
      JSON.stringify(prevStateRef.current) === JSON.stringify(prereadState);
    if (isSame) return;

    if (saveTimer.current) clearTimeout(saveTimer.current);

    saveTimer.current = setTimeout(() => {
      localStorage.setItem("prereadStateLocal", JSON.stringify(prereadState));
      prevStateRef.current = prereadState; // update prev state
    }, 5000);

    return () => {
      if (saveTimer.current) clearTimeout(saveTimer.current);
    };
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const totalSize = attachMent.reduce((acc, f) => acc + f.size, 0);

    // ✅ validation
    if (!validateFile(file)) return;

    // ❌ Total size check
    if (totalSize + file.size > 10 * 1024 * 1024) {
      toast.error("Total upload size must be under 10MB");
      return;
    }

    const formData = new FormData();
    formData.append("uploadQuestionAttachment", file);

    setLoader(true);

    axios
      .post(
        `/api/v1/question/uploadAttachment/teacherId/${Teacher_Json}`,
        formData,
      )
      .then((response) => {
        setAttachment((prev) => [...prev, file]);
        setAttach((prev) => [...prev, response.data.data]);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        toast.error("Error uploading file");
      })
      .finally(() => {
        setLoader(false);
      });
  };
  async function handleTakePhoto(dataUri) {
    const now = new Date();

    // Format date parts
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const fileExtension = "jpg" || "jpeg" || "png";
    const filename = `capture-${day}-${month}-${year}-${hours}:${minutes}:${seconds}.${fileExtension}`;
    console.log("filename", filename);

    const link = document.createElement("a");
    link.href = dataUri;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    try {
      const capture = await fetch(dataUri).then((res) => res.blob());
      const fileWithProperExtension = new File([capture], filename, {
        type: capture.type || "image/jpeg",
      });

      if (
        fileWithProperExtension.size <= 25 * 1024 * 1024 &&
        validateFile(fileWithProperExtension)
      ) {
        const formData = new FormData();
        formData.append("name", filename);
        formData.append("uploadQuestionAttachment", fileWithProperExtension);
        // formData.append("image", blob, `${new Date().getTime()}.jpg`); // Provide a filename
        console.log("formData", formData);

        let response = await axios.post(
          `/api/v1/question/uploadAttachment/teacherId/${Teacher_Json}`,
          formData,
        );

        if (response) {
          console.log("response fom take phtoto", response);
          let currectAttachment = [];
          setAttachment((prev) => {
            currectAttachment = [...prev, fileWithProperExtension];
            return currectAttachment;
          });
          setAttach((prev) => {
            const updatedAttach = [...prev, response?.data?.data];
            return updatedAttach;
          });
          response && setLoader(false);
        } else {
          console.error("Failed to upload photo:", response.statusText);
          alert("Failed to upload photo.");
        }
      } else {
        setIsValidFileType(false);
      }
    } catch (error) {
      console.error("Error uploading photo:", error);
      alert("An error occurred during the upload.");
    } finally {
      setIsCameraOpen(false);
    }
  }

  console.log(attach, "attach frpm take photo");

  const onChangeLinkValue = (value) => {
    setLinkValue(value);
  };

  const handleSaveLink = () => {
    if (attach.length >= 5) {
      toast.error("Maximum 5 attachments allowed");
      return;
    }

    if (linkValue.trim() === "" || !linkValue.startsWith("https://")) {
      toast.error("Please enter a valid link.");
      return;
    }

    setAttach((prev) => [...prev, linkValue]);
    setLinkValue("");
    setShowLinkBox(false);
  };
  const handleBackNavigation = () => {
    if (state?.fromLiveSession === "liveSession") {
      navigate("/liveSession", {
        state: {
          supplement_id: state?.supplement_id,
          addMaterial: state?.redirectStateData?.addMaterial,
          standardId: state?.standardId,
          sectionId: state?.sectionId,
          Subject_id: state?.subjectId ?? state?.Subject_id,
          buttonfunction: state?.redirectStateData?.buttonfunction,
          sectionName: state?.redirectStateData?.sectionName,
          standardsName: state?.redirectStateData?.standardsName,
        },
      });
    } else {
      navigate("/PublishedHomeworkPreRead");
    }
  };

  return (
    <div
      className="orange-scrollBar"
      style={{ height: "600px", overflowY: "scroll" }}
    >
      <div className="d-flex gap-2 align-items-center">
        <IoIosArrowBack
          onClick={() => {
            handleBackNavigation();
          }}
          style={{ cursor: "pointer" }}
        />

        <div
          className="d-flex flex-column gap-1"
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleBackNavigation();
          }}
        >
          <span className="head_manual">Pre-read</span>
          <span className="fw-small  text-muted" style={{ fontSize: "10px" }}>
            Dashboard / Assignment / Create Pre-read
          </span>
        </div>
      </div>
      <div
        className="d-flex flex-column h-100 w-auto  p-4 mt-2"
        style={{ backgroundColor: "white" }}
      >
        <div className="poppins-semibold ml-5">Create Pre-read</div>

        <div className=" total-dropdown">
          <div class="mb-2 ">
            <input
              maxLength={100}
              value={prereadState.tittle}
              type="text"
              id="txt-i-first"
              placeholder="Enter title"
              className="form-control box_height "
              onChange={(e) =>
                setPrereadState({
                  ...prereadState,
                  tittle: e.target.value,
                })
              }
            />
            {errors.tittle && <span className="error">{errors.tittle}</span>}
          </div>

          <div
            className="create-dropdown1 mt-4"
            style={{ paddingRight: "4rem" }}
          >
            <select
              isMulti
              className="form-select col-4 "
              id={
                state?.defaultData !== undefined
                  ? "bello"
                  : prereadState.classes === ""
                    ? "bello"
                    : "bye"
              }
              aria-label="Default select example"
              disabled={state?.defaultData !== undefined ? true : false}
              value={classes}
              onChange={(e) => {
                setPrereadState({
                  ...prereadState,
                  classes: e.target.value,
                  subjects: "",
                  sections: "",
                });
                res = getSelectedValueSE();
              }}
            >
              <option selected value="">
                Select Class
              </option>
              {standardArr &&
                standardArr.length > 0 &&
                standardArr
                  .sort((a, b) => {
                    const aNum = Number(a.name);
                    const bNum = Number(b.name);

                    const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                    if (bothNumeric) {
                      return aNum - bNum; // numeric sort
                    }

                    return a.name.localeCompare(b.name); // alphabetical sort
                  })
                  .map((standeredList) => (
                    <>
                      <option
                        className="options_style"
                        value={[standeredList.name, standeredList.id]}
                      >
                        {standeredList.name}
                      </option>
                    </>
                  ))}
            </select>
            <select
              disabled={state?.defaultData !== undefined ? true : false}
              className="form-select ml-2 col-4  "
              id={
                state?.defaultData !== undefined
                  ? "bello"
                  : prereadState.sections === ""
                    ? "bello"
                    : "bye"
              }
              aria-label="Default select example"
              value={sections}
              onChange={(e) =>
                setPrereadState({
                  ...prereadState,
                  sections: e.target.value,
                  subjects: "",
                })
              }
            >
              <option value="">Select Section</option>
              {/* {console.log("sectionArr5", sectionArr)} */}
              {sectionArr &&
                prereadState.classes !== "" &&
                sectionArr.length > 0 &&
                sectionArr.map((sectionList) => (
                  <option
                    className="options_style"
                    value={[sectionList.name, sectionList.id]}
                  >
                    {sectionList.name}
                  </option>
                ))}
            </select>

            <select
              className="form-select ml-2 col-4  "
              id={
                state?.defaultData !== undefined
                  ? "bello"
                  : prereadState.subjects === ""
                    ? "bello"
                    : "bye"
              }
              disabled={state?.defaultData !== undefined ? true : false}
              value={subjects}
              onChange={(e) =>
                setPrereadState({
                  ...prereadState,
                  subjects: e.target.value,
                })
              }
            >
              <option selected value="">
                Select Subject
              </option>
              {/* {console.log("subjectDropdown5", subjectsList)} */}
              {subjectsList &&
                prereadState.classes !== "" &&
                prereadState.sections !== "" &&
                subjectsList.length > 0 &&
                subjectsList.map((subjectList) => (
                  <option
                    className="options_style"
                    value={[subjectList.name, subjectList.id]}
                  >
                    {subjectList.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="create-dropdown1 mt-4 ">
            <select
              isMulti
              className="form-select mt-2 col-6"
              id={prereadState.chapters === "" ? "bello" : "bye"}
              onChange={(e) =>
                setPrereadState({
                  ...prereadState,
                  chapters: e.target.value,
                  book: e.target.options[e.target.selectedIndex].getAttribute(
                    "book-id",
                  ),
                })
              }
              value={chapters}
            >
              <option value="">Select Chapter</option>
              {chapterDropdown?.length > 0 &&
                chapterDropdown?.map((item) =>
                  item.bookInfo.map((book) => (
                    <optgroup
                      label={book.name}
                      key={book.id}
                      book-id={book.id}
                      style={{ color: "black" }}
                    >
                      {book.chapterData.map((chapter) => (
                        <option
                          key={chapter.id}
                          book-id={book.id}
                          book-name={book.name}
                          value={chapter.id}
                          style={{ color: "black" }}
                        >
                          {chapter.chapterName}
                        </option>
                      ))}
                    </optgroup>
                  )),
                )}
            </select>

            <select
              className="form-select mt-2 ml-2 "
              id={prereadState.pretypes === "" ? "bello" : "bye"}
              aria-label="Default select example"
              onChange={(e) =>
                setPrereadState({
                  ...prereadState,
                  pretypes: e.target.value,
                })
              }
              value={pretypes}
            >
              <option value="">Pre-read Type</option>

              {pretypeDropdown &&
                pretypeDropdown.length > 0 &&
                pretypeDropdown.map((prereadList) => (
                  <option
                    className="options_style"
                    value={[prereadList.name, prereadList.id]}
                  >
                    {prereadList.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="form-group mt-4">
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Control
                maxLength={250}
                as="textarea"
                placeholder="Description"
                rows={4}
                value={prereadState.description}
                className="px-3 py-2 placeholderColor"
                onChange={(e) =>
                  setPrereadState({
                    ...prereadState,
                    description: e.target.value,
                  })
                }
              />
              {errors.description && (
                <span className="error">{errors.description}</span>
              )}
            </Form.Group>
          </div>

          <Box
          // sx={{
          //   mt: 3,
          //   mr: 3,
          //   p: 2,
          //   borderRadius: 2,
          //   bgcolor: "#fafafa",
          //   boxShadow: "0px 1px 4px rgba(0,0,0,0.08)",
          // }}
          >
            {/* Buttons Row */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={3}
              flexWrap="wrap"
              justifyContent="flex-start"
            >
              {/* Add Link */}
              <Box
                onClick={() => !isProcessing && setShowLinkBox(!showLinkBox)}
                style={{
                  opacity: isProcessing ? 0.5 : 1,
                  pointerEvents: isProcessing ? "none" : "auto",
                }}
                className="cameraContainerActivity"
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Link size={20} />
                <Typography
                  variant="body2"
                  className="uploadHereText"
                  sx={{ fontWeight: 500 }}
                >
                  Add Link
                </Typography>
              </Box>

              {/* Upload Files */}
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <input
                  type="file"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  id="attachFile"
                  style={{ display: "none" }}
                  disable={isProcessing}
                  onInput={(e) => {
                    handleFileChange(e);
                    e.target.value = null;
                  }}
                />

                <label htmlFor="attachFile" style={{ cursor: "pointer" }}>
                  <span className="cameraContainerAddAttachment d-flex align-items-center">
                    <img
                      src={assets.UploadIcon}
                      alt=""
                      style={{ width: "28px" }}
                    />
                    <Typography
                      variant="body2"
                      className="uploadHereText"
                      sx={{ ml: 1, fontWeight: 500 }}
                    >
                      Upload files
                    </Typography>
                  </span>
                </label>

                {loader && <CircularProgress size={22} sx={{ ml: 1 }} />}
                {errorsize && (
                  <Typography color="error">File must be under 10MB</Typography>
                )}
              </Box>

              {/* Camera Upload */}
              {!isCameraOpen ? (
                <Box
                  onClick={() => !isProcessing && setShowLinkBox(!showLinkBox)}
                  style={{
                    opacity: isProcessing ? 0.5 : 1,
                    pointerEvents: isProcessing ? "none" : "auto",
                  }}
                  className="d-flex align-items-center gap-2 cameraContainerActivity"
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <img
                    src="/images/CameranewIcon.png"
                    alt=""
                    style={{ width: "33px" }}
                  />
                  <Typography
                    variant="body2"
                    className="uploadHereText"
                    sx={{ fontWeight: 500 }}
                  >
                    Take Photo
                  </Typography>
                </Box>
              ) : (
                <Box
                  className="opened_camera"
                  sx={{
                    mt: 2,
                    width: "100%",
                    position: "relative",
                    borderRadius: 2,
                    border: "1px solid #e0e0e0",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                    overflow: "hidden",
                    backgroundColor: "#fafafa",
                  }}
                >
                  {/* Close Icon */}
                  <IconButton
                    onClick={() => setIsCameraOpen(false)}
                    size="small"
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      zIndex: 10,
                      backgroundColor: "rgba(255,255,255,0.8)",
                      "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                    }}
                  >
                    <img
                      src={assets.closeIcon}
                      alt="close"
                      width={20}
                      height={20}
                    />
                  </IconButton>

                  {/* Camera Component */}
                  <Box sx={{ position: "relative" }}>
                    <Camera
                      onTakePhoto={handleTakePhoto}
                      idealFacingMode="environment"
                      isImageMirror={false}
                      imageCompression={0.97}
                      isMaxResolution={true}
                      isSilentMode={false}
                      className="custom-camera"
                      // onCameraError={handleCameraError}
                    />
                  </Box>

                  {/* Camera Error Message */}
                  {cameraError && (
                    <Box
                      sx={{
                        mt: 1.5,
                        mx: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#ffebee",
                        border: "1px solid #f44336",
                        color: "#c62828",
                        borderRadius: 1,
                        px: 2,
                        py: 1,
                        width: "fit-content",
                        fontSize: "0.9rem",
                      }}
                    >
                      <ReportProblemRoundedIcon
                        sx={{ mr: 1, fontSize: "1.2rem", color: "#f44336" }}
                      />
                      {cameraError}
                    </Box>
                  )}
                </Box>
              )}
            </Stack>

            {/* Attachments List */}
            <Box
              sx={{
                mt: 2,
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                gap: 2,
              }}
            >
              {attach &&
                attach.map((obj, index) => (
                  <Attachment
                    key={index}
                    newPreRead={newPreRead}
                    setAttach={setPrereadState}
                    prereadState={prereadState}
                    attach={obj}
                    handleAttach={handleAttach}
                    id={index}
                  />
                ))}
            </Box>
          </Box>

          <div class="me-2 mb-4  gap-2 d-md-flex justify-content-end ">
            {!isDisableButtons1 && (
              <button
                className={
                  isDisableButtons
                    ? "btn px-3 m-1 mt-2 py-2 pre_Draft_buttonDisable"
                    : "btn px-3 m-1 py-2 mt-2 pre_Draft_button"
                }
                onClick={() => {
                  helper();
                }}
                disabled={isDisableButtons}
              >
                Save as Draft
              </button>
            )}

            <button
              className={
                isDisableButtons
                  ? "btn px-5 mx-1 mt-2 py-2 prer_publish_buttonDisable"
                  : "btn px-5 mx-1 py-2 mt-2 prer_publish_button"
              }
              onClick={(e) => {
                setPublish(true);
              }}
              disabled={isDisableButtons}
            >
              Publish
            </button>
          </div>
        </div>

        {publish && (
          <CreatePublishPreRead
            prereadState={prereadState}
            newPreRead={newPreRead}
            attachMent={attachMent}
            setPublish={setPublish}
            attach={attach}
            redirectStateData={state?.redirectStateData ?? null}
          />
        )}
        {showLinkBox && (
          <AddLinkPopup
            setShowLinkBox={setShowLinkBox}
            onChangeLinkValue={onChangeLinkValue}
            linkValue={linkValue}
            handleSaveLink={handleSaveLink}
          />
        )}
        {/* {errorsize && <FileSize setErrorSize={setErrorSize} />}
      {errortype && <FileType setErrorSize={setErrorType} />} */}
      </div>
    </div>
  );
}
export default CreatePreRead;
